import {throwIfUndefined} from '@coolcolduk/util';
import {
  mapStringToEnumValueValidated,
  mapTradeDbToType,
  mapTradeWriteToDb,
  Trade,
  TradeDirection,
  TradeStatus,
  TradeWrite,
} from '@cp/model';
import {addDoc, getDoc, serverTimestamp} from 'firebase/firestore';
import {getCurrentUserIdValidated} from '../../config/firebase';
import {getTradeCollection} from './getTradeCollection';

export async function createTrade(input: {
  symbol: string;
  sessionId: string;
  direction: TradeDirection | string;
  entryPrice: number;
  exitPrice?: number;
  status: TradeStatus | string;
  tags?: string[];
  screenshotStoragePath?: string;
}): Promise<Trade> {
  const uid = await getCurrentUserIdValidated();

  const createdAt = serverTimestamp() as any;
  const openedAt = serverTimestamp() as any;

  const resolvedDirection = mapStringToEnumValueValidated(TradeDirection, input.direction, 'Invalid trade direction');
  const resolvedStatus = mapStringToEnumValueValidated(TradeStatus, input.status, 'Invalid trade status');

  const tradeWrite: TradeWrite = {
    sessionId: input.sessionId,
    symbol: input.symbol,
    entryPrice: input.entryPrice,
    direction: resolvedDirection,
    exitPrice: input.exitPrice,
    status: resolvedStatus,
    openedAt,
    closedAt: resolvedStatus === TradeStatus.OPEN ? undefined : (serverTimestamp() as any),
    createdAt,
    tags: input.tags ?? [],
    message: input.screenshotStoragePath
      ? {
          note: '',
          screenshotStoragePath: input.screenshotStoragePath,
          createdAt,
        }
      : undefined,
  };

  const data = mapTradeWriteToDb(tradeWrite, createdAt);
  const ref = await addDoc(getTradeCollection(uid), data);
  const snap = await getDoc(ref);

  return throwIfUndefined(mapTradeDbToType(snap as any));
}
